import namespace from '@/store/namespace'
export default namespace('Solicitud',{
    getters:[
        'GetDatosSolicitud',
        'GetDatosEmpresa'
    ],
    actions:[
        'RegistrarSolicitud',
        'EnviarSolicitud',
        'LimpiarSolicitudTodos',
        'LimpiarSolicitudAmpliacion',
        'ObtenerSolicitud',
        'EliminarSolicitud',
        'LimpiarSolicitudDesistimiento',
        'LimpiarSolicitudDocsPosteriores',
        'LimpiarInclusionExclusion',
        'ObtenerDatosEmpresa',
        'SeguimientoTramite',
        'BusquedaTramite',
        'ActualizarSolicitud',
        'filtroSolicitud',
        'horarioAtencionByOficinaId',
        'horarioTopeAtencionByOficinaId',
        'detalleSolicitud',
        'detalleSolicitudPajelV1'
    ],
    mutations:[
        'SetDatosSolicitud',
        'SetDatosEmpresa'
    ]
})
